export default __webpack_public_path__ + "img/eKceeXBj.485bbe00.svg";